import { useQuery } from '@tanstack/react-query';

import { fetchUserTypes, type IUserTypeOption } from '@/services/admin';

export function useUserTypes() {
  const { data, isLoading } = useQuery<IUserTypeOption[], Error>({
    queryKey: ['userTypes'],
    queryFn: fetchUserTypes,
    staleTime: 5 * 60 * 1000,
  });

  return { userTypes: data ?? [], loading: isLoading };
}
